import { FC } from "react";
import { SignIn } from "../../../../modules/authentication/sign-in/sign-in";

export const SignInRoute: FC = () => {
    return (
        <SignIn />
    )
}